'use client';
import AppBar from '@mui/material/AppBar';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

type Props = {
  customerSetting: CustomerSetting;
};

export const Footer: React.FC<Props> = ({ customerSetting }) => {
  const theme = useTheme();
  const {
    footer: { copyRightYear },
    siteName
  } = customerSetting;
  return (
    <AppBar component="footer" position="static" sx={{ marginTop: 'auto' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography
          variant="caption"
          color={theme.palette.primary.contrastText}
        >
          {`© Copyright ${copyRightYear} ${siteName}. All rights reserved.`}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
